// React import
import React, { Fragment, useEffect, useState, useCallback } from 'react';
//Material component import
import {Divider, Select, MenuItem, InputLabel  } from "@mui/material";
// custom component import
import styles from "./DailyProductionInsight.module.css";
import InsightTable from 'Samarth Module/components/table/insightTable';
import ProductionPlanComparisonGraph from './ProductionPlanComparisonGraph';
import { CircularProgress } from "@mui/material";


const ProductionPlanComparsion =({data, loader})=> {
    const [selectedPlan, setSelectedPlan] = useState('All');
    const [tableData, setTableData] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [dbData, setDbData] = useState([]);
    const [dbTableData, setDbTableData] = useState([]);
    const [planList, setPlanList] = useState([]);
    
    useEffect(() => {
        if(data?.length > 0){
            const allKeys = Object.keys(data[0])?.filter(key => key !== 'date');
            const result = allKeys.map(label => {
                let row = { "Planned quantity": label };
                data.forEach(entry => {
                    row[entry.date] = entry[label];
                });
                return row;
            });
            setDbData(data); //save for further filter.
            setDbTableData(result); //save for further filter.
            setTableData(result); //for display table data.
            setGraphData(data); // for display graph
            setPlanList(Object.keys(data[0])?.filter(key => key !== 'date')); //for plan dropdown option
        }
        setSelectedPlan('All');
    }, [data]);

    const planHandleChange = useCallback ((e)=>{
        setSelectedPlan((prev)=> e.target.value);
        // filter graph data and set
        const tempgraphData = 'All' === e.target.value ? dbData : dbData?.map(itm=>({"Actual production":itm["Actual production"], [e.target.value]:itm[e.target.value], "date":itm.date}))
        setGraphData(tempgraphData);
        // filter table data and set
        const tempTableData = 'All' === e.target.value ? dbTableData : dbTableData?.filter(itm=>itm["Planned quantity"] === e.target.value);
        setTableData(tempTableData);
    }, [dbTableData, dbData]);
	return(
		<Fragment>
            <div className={styles.graphDiv}>
                <div className={styles.planText}><span>Production plan comparison</span></div>
                <Divider className={styles.hr}/>
                {loader ? 
                <div className={styles.loaderContainer}><CircularProgress /></div> :
                <>
                    <div className={styles.menuItem}>
                        <InputLabel htmlFor="plan" className={styles.label} style={{ color:'#4D4D4F' }}>Plan</InputLabel>
                        <Select
                            id="plan"
                            value={selectedPlan}
                            onChange={planHandleChange}
                            size="small"
                            className={styles.selectedOption}
                        >
                            <MenuItem className={styles.listItem} value="All">Select All</MenuItem>
                            {planList.map((line) => (
                                <MenuItem className={styles.listItem} key={line} value={line}>
                                    {line}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <ProductionPlanComparisonGraph data={graphData} />
                    <InsightTable data={tableData}/>
                </>}
            </div>
		</Fragment>
	);
}

export default ProductionPlanComparsion;